var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title', {
    staticClass: "headline pb-0 pt-3",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(" About Multinet ")]), _c('v-card-text', {
    staticClass: "px-4 pt-4 pb-1"
  }, [_vm._v(" Multinet is a system for storing and processing "), _c('a-ext', {
    attrs: {
      "href": "https://vdl.sci.utah.edu/mvnv/"
    }
  }, [_vm._v("multivariate networks")]), _vm._v(". Learn more and explore the code at "), _c('a-ext', {
    attrs: {
      "href": "https://github.com/multinet-app/multinet-api"
    }
  }, [_vm._v("GitHub")]), _vm._v(". ")], 1), _c('v-card-text', {
    staticClass: "px-4 pt-4 pb-1"
  }, [_vm._v(" Check out the Multinet project "), _c('a-ext', {
    attrs: {
      "href": "https://multinet-app.readthedocs.io"
    }
  }, [_vm._v("documentation")]), _vm._v(", "), _vm._v(" or the "), _c('a-ext', {
    attrs: {
      "href": "https://api.multinet.app/swagger"
    }
  }, [_vm._v("API docs")]), _vm._v(". ")], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-4 py-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "grey darken-3",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggle');
      }
    }
  }, [_vm._v(" OK ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }